export default "__VITE_ASSET__B43Y2UPQ__"